import { latestVideos } from '@/mocks/home';
import VideoCard from '@/components/feature/VideoCard';

export default function LatestContent() {
  return (
    <section className="w-full px-4 md:px-6 py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新内容
            </h2>
            <p className="text-foreground-500 text-sm">刚刚上线的新鲜视频</p>
          </div>
          <button className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
            查看更多
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <button className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
            查看更多
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}